import ErrorIcon from '@mui/icons-material/Error';
import { Button, Grid, Typography } from '@mui/material';
import { FC } from 'react';
import { colors } from '~/theme';

export const ErrorBox: FC<Props> = ({ title, message, retry, cancel }) => {
  return (
    <>
      <Typography sx={{ fontWeight: 'bold', fontSize: '1.5rem' }}>{title}</Typography>
      <ErrorIcon sx={{ fontSize: '100px', mt: 4, mb: 2, color: colors.darkYellow }} />
      {message.split('\n').map((line, idx) => (
        <Typography key={idx}>{line}</Typography>
      ))}
      <Grid container justifyContent="center">
        {cancel && (
          <Grid item xs={12} md={6} mt={4}>
            <Button onClick={cancel} fullWidth sx={{ height: '50px', fontWeight: 'bold', fontSize: '1rem' }}>
              Voltar
            </Button>
          </Grid>
        )}
        {retry && (
          <Grid item xs={12} md={6} mt={4}>
            <Button
              onClick={retry}
              fullWidth
              variant="contained"
              sx={{ height: '50px', fontWeight: 'bold', fontSize: '1rem' }}
            >
              Tentar novamente
            </Button>
          </Grid>
        )}
      </Grid>
    </>
  );
};

interface Props {
  title: string;
  message: string;
  retry?: () => void;
  cancel?: () => void;
}
